import { Api } from "./Api";
import axios from "axios/index";
import { Audit } from "../models/Audit";
import Evenement = Audit.Evenement;

export class AuditApi extends Api {
    constructor() {
        super("audit");
    }

    getEvenement(
        auditId: number,
        evenementId: number,
        params?: Object
    ): Promise<Evenement> {
        return axios
            .get(this.apiUrl + auditId + "/evenement/" + evenementId, {
                params: params,
            })
            .then(function (response) {
                return new Evenement(response.data.data);
            });
    }

    updateEvenement(evenement: Evenement): Promise<Evenement> {
        return axios
            .put(
                this.apiUrl + evenement.audit_id + "/evenement/" + evenement.id,
                evenement
            )
            .then(function (response) {
                return new Evenement(response.data.data);
            });
    }

    getEvenementByHash(hash: string, params?: Object): Promise<Evenement> {
        return axios
            .get(this.apiUrl + "evenement/hash/" + hash, { params: params })
            .then(function (response) {
                return new Evenement(response.data.data);
            });
    }
}
